import { useTranslation } from '@/i18n';
import { IconHelp, Tooltip } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames';
import { FC } from 'react';
import styles from './styles.module.scss';
type Props = {
  disabled: boolean;
};

const cx = classnames.bind(styles);

export const SendMailItem: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <div className={cx(styles.itemContainer)}>
      <div
        className={cx({
          [styles.disabled]: disabled,
        })}
        role='button'
        aria-disabled={disabled}
      >
        <span>{t('instruction_menu_email_send')}</span>
      </div>
      <Tooltip
        title={t('instruction_menu_email_send_tooltip')}
        placement='right'
      >
        <span
          className={cx(styles.iconContainer, {
            [styles.disabled]: disabled,
          })}
        >
          <IconHelp size={16} />
        </span>
      </Tooltip>
    </div>
  );
};
